import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ToolbarModule } from 'primeng/toolbar';

import { SupervisorMainComponent } from './supervisor-main.component';
import { SharedModule } from '../shared/shared.module';
import { SupervisorRoutingModule } from './supervisor.routing.module';
import { ProgramsComponent } from './programs/programs.component';
import { PlaylistsComponent } from './playlists/playlists.component';
import { TargetsComponent } from './targets/targets.component';
import { ProgramComponent } from './programs/program/program.component';
import { PlaylistComponent } from './playlists/playlist/playlist.component';
import { AddProgramComponent } from './programs/add-program/add-program.component';
import { AddPlaylistComponent } from './playlists/add-playlist/add-playlist.component';
import { AddTargetComponent } from './targets/add-target/add-target.component';
import { TargetComponent } from './targets/target/target.component';
import { AddStaffAlertComponent } from './add-staff-alert/add-staff-alert.component';
import { DragDropModule } from 'primeng/dragdrop';
import { TooltipModule } from 'primeng/tooltip';
import { ToggleButtonModule } from 'primeng/togglebutton';
import {
  CdkDragDrop,
  CdkDropList,
  CdkDrag,
  moveItemInArray,
} from '@angular/cdk/drag-drop';

import { SkillAreasComponent } from './skill-areas/skill-areas.component';
import { AddSkillAreaComponent } from './skill-areas/add-skill-area/add-skill-area.component';
import { RemindersComponent } from './reminders/reminders.component';
import { AddReminderComponent } from './reminders/add-reminder/add-reminder.component';
import { SkillAreaComponent } from './skill-areas/skill-area/skill-area.component';
import { ReminderComponent } from './reminders/reminder/reminder.component';
import { BehaviorsComponent } from './behaviors/behaviors.component';
import { AddBehaviorComponent } from './behaviors/add-behavior/add-behavior.component';
import { BehaviorComponent } from './behaviors/behavior/behavior.component';
import { PromptCodesPatientComponent } from './prompt-codes/prompt-codes-patient.component';
import { SettingsModule } from '../settings/settings.module';
import { PromptCodesComponent } from '../settings/prompt-codes/prompt-codes.component';
import { PromptCodeComponent } from '../settings/prompt-codes/prompt-code/prompt-code.component';
import { AddPromptCodeComponent } from '../settings/prompt-codes/add-prompt-code/add-prompt-code.component';
import { PromptSchedulesComponent } from '../settings/prompt-schedules/prompt-schedules.component';
import { PromptScheduleComponent } from '../settings/prompt-schedules/prompt-schedule/prompt-schedule.component';
import { AddPromptScheduleComponent } from '../settings/prompt-schedules/add-prompt-schedule/add-prompt-schedule.component';
import { SettingsMainComponent } from '../settings/settings-main.component';
import { PromptSchedulesPatientComponent } from './prompt-schedules/prompt-schedules-patient.component';
import { GraphsModule } from '../graphs/graphs.module';
import { MaintananceCriteriasComponent } from '../settings/maintanance-criterias/maintanance-criterias.component';
import { MaintananceCriteriaPatientComponent } from './maintanance-criteria/maintanance-criteria-patient.component';
import { MasteryCriteriaComponent } from '../settings/mastery-criteria/mastery-criteria.component';
import { ProbeCriteriaComponent } from '../settings/probe-criteria/probe-criteria.component';
import { AntecedentsComponent } from './abc/antecendents/antecedents.component';
import { AntecedentComponent } from './abc/antecendents/antecedent/antecedent.component';
import { AddAntecedentComponent } from './abc/antecendents/add-antecedent/add-antecedent.component';
import { ConsequencesComponent } from './abc/consequences/consequences.component';
import { ConsequenceComponent } from './abc/consequences/consequence/consequence.component';
import { AddConsequenceComponent } from './abc/consequences/add-consequence/add-consequence.component';
import { ImportDataComponent } from './import-data/import-data.component';
import { InstructionsComponent } from './instructions/instructions.component';
import { NotesComponent } from './notes/notes.component';
import { TableModule } from 'primeng/table';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DividerModule } from 'primeng/divider';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PanelModule } from 'primeng/panel';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AlertHtmlComponent } from '../shared/alerts/alert-html/alert-html.component';
import { RawDataComponent } from './targets/rawdata/rawdata.component';
import { StaffModule } from '../staff/staff.module';
import { RawDataBehaviorComponent } from './behaviors/rawdata/rawdata-behavior.component';
import { OverviewComponent } from './overview/overview.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MergeTargetsComponent } from './merge-targets/merge-targets.component';
import { MergeBehaviorsComponent } from './merge-behaviors/merge-behaviors.component';
import { MoveSessionDataComponent } from './move-session-data/move-session-data.component';
import { BipListComponent } from './bip/bip-list/bip-list.component';
import { CdkObserveContent } from "@angular/cdk/observers";
import { BehaviorBipInfoComponent } from './behaviors/behavior-bip-info/behavior-bip-info.component';
import { BipQuickReferenceComponent } from './bip/bip-quick-reference/bip-quick-reference.component';
import { StaffManagementReportComponent } from './management-report/staff-management-report.component';
import { GeneralSettingsInfoComponent } from '../shared/components/general-settings-info/general-settings-info.component';

const pages = [
  SupervisorMainComponent,
  ProgramsComponent,
  PlaylistsComponent,
  TargetsComponent,
  ProgramComponent,
  PlaylistComponent,
  AddProgramComponent,
  AddPlaylistComponent,
  AddTargetComponent,
  TargetComponent,
  AddStaffAlertComponent,
  SkillAreasComponent,
  AddSkillAreaComponent,
  RemindersComponent,
  AddReminderComponent,
  SkillAreaComponent,
  ReminderComponent,
  BehaviorsComponent,
  AddBehaviorComponent,
  BehaviorComponent,
  PromptCodesPatientComponent,
  PromptSchedulesPatientComponent,
  InstructionsComponent,
  NotesComponent,
  SettingsMainComponent,
  PromptCodesComponent,
  PromptCodeComponent,
  AddPromptCodeComponent,
  PromptSchedulesComponent,
  PromptScheduleComponent,
  AddPromptScheduleComponent,
  MaintananceCriteriasComponent,
  MaintananceCriteriaPatientComponent,
  MasteryCriteriaComponent,
  ProbeCriteriaComponent,
  AntecedentsComponent,
  AntecedentComponent,
  AddAntecedentComponent,
  ConsequencesComponent,
  ConsequenceComponent,
  AddConsequenceComponent,
  ImportDataComponent,
  RawDataComponent,
  RawDataBehaviorComponent,
  OverviewComponent,
  MergeTargetsComponent,
  MergeBehaviorsComponent,
  BipListComponent,
  StaffManagementReportComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    GraphsModule,
    SupervisorRoutingModule,
    StaffModule,
    BehaviorBipInfoComponent,
    DragDropModule,
    InputNumberModule,
    CdkDropList,
    CdkDrag,
    InputSwitchModule,
    ToolbarModule,
    SettingsModule,
    TableModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    CardModule,
    FloatLabelModule,
    DividerModule,
    OverlayPanelModule,
    PanelModule,
    CKEditorModule,
    NgApexchartsModule,
    OverlayPanelModule,
    TooltipModule,
    ToggleButtonModule,
    CdkObserveContent,
    GeneralSettingsInfoComponent
],
  declarations: [...pages, MoveSessionDataComponent],
})
export class SupervisorModule {
  constructor(@Optional() @SkipSelf() parentModule: SupervisorModule) {
    if (parentModule) {
      throw new Error(
        'Module is already loaded. Import in your base AppModule only.'
      );
    }
  }
}
